export const validateName = (value:string):string => value
  .trim()
  .replace(/[^\w\d\s\(\)\p{sc=Cyrillic}]/ug, '')

export const validatePhone = (value:string):string => value
  .replace(/\+/g, (symbol:string, index:number) => index > 0 ? '' : symbol)
  .replace(/[^0-9\+]/g, '')

export const isRoomsHasDublicateFullnames = (rooms:any) => rooms.some((outerRoom:any, outerIndex:number) => {
  const outerFirstName = outerRoom?.firstName?.trim() || ''
  const outerLastName = outerRoom?.lastName?.trim() || ''
  const outerFullName = (outerFirstName + outerLastName).toLowerCase()
  
  // Skip if outer room doesn't have both name fields filled
  if (!outerFirstName || !outerLastName) {
    return false
  }
  
  return rooms.some((room:any, index:number) => {
    if (outerIndex === index) return false
    
    const roomFirstName = room?.firstName?.trim() || ''
    const roomLastName = room?.lastName?.trim() || ''
    const roomFullName = (roomFirstName + roomLastName).toLowerCase()
    
    // Only check for duplicates if both rooms have both name fields filled
    if (!roomFirstName || !roomLastName) {
      return false
    }
    
    return outerFullName === roomFullName
  })
})

export const isRoomsHaveDublicatePhoneNumbers = (rooms:any) => rooms.some((outerRoom:any, outerIndex:number) => {
  const outerPhone = outerRoom?.phoneNumber?.trim() || ''
  
  // Skip if outer room doesn't have phone number filled
  if (!outerPhone) {
    return false
  }
  
  const outerPhoneNormalized = outerPhone.replace(/\D/g, '')
  
  return rooms.some((room:any, index:number) => {
    if (outerIndex === index) return false
    
    const roomPhone = room?.phoneNumber?.trim() || ''
    
    // Only check for duplicates if both rooms have phone numbers filled
    if (!roomPhone) {
      return false
    }
    
    const roomPhoneNormalized = roomPhone.replace(/\D/g, '')
    return outerPhoneNormalized === roomPhoneNormalized
  })
})